import React from 'react';
import { ModalContainer } from '@welbe/web-design-system';
import { AiOutlineClose as Close } from 'react-icons/ai';

import {
	Container,
	CloseBackground,
	ContentTitle,
	Content,
	ContentButton,
	Icon,
} from './ModalCustomAction.styles';

import { Candidate } from 'types';

type ModalCustomActionProps = {
	selectedCandidates?: Candidate[];
	icon: any;
	titleText: string;
	descriptionText?: string;
	buttons: JSX.Element[];
	height: string;
	zIndex?: number;
	handleClose: () => void;
};

export const ModalCustomAction = ({
	icon,
	titleText,
	descriptionText,
	buttons,
	height,
	zIndex = 1100,
	handleClose,
}: ModalCustomActionProps): JSX.Element => {
	return (
		<ModalContainer
			visible
			height={height}
			zIndex={zIndex}
			headerIcon={<Icon src={icon} />}
			closeOnlyOnTheButton
		>
			<Container>
				<CloseBackground onClick={handleClose}>
					<Close fontSize="medium" />
				</CloseBackground>

				<ContentTitle>{titleText}</ContentTitle>
				{descriptionText && <Content>{descriptionText}</Content>}
				<ContentButton>{buttons}</ContentButton>
			</Container>
		</ModalContainer>
	);
};
